import React from "react";
export const HardwareContext = React.createContext({});
